import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'notif-danger',
  templateUrl: './notif-danger.component.html',
  styleUrls: ['./notif-danger.component.css']
})
export class NotifDangerComponent implements OnInit {
  @Input() msg : string;
  @Input() closable : string;
  constructor() { }

  ngOnInit() {
  }

}
